import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { QueovalParam, BreadcrumbModel, BreadDik, QueovalItem, BlockTree, EventsModel, Apprenant, BObjectModel } from '../../models';
import { CoreService, HttpService } from '../../services';
import { ToastService } from '../../toast';
import { DialogService } from '../../dialog';
import { Subscription} from 'rxjs';
import { AgendaQueovalService } from '../agenda.queoval.services';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.css']
})

export class ReservationComponent implements OnInit, OnDestroy {

  globalSaveStage: boolean = false;
  public globalPresence: string = '';
  paramModel: BObjectModel;
  baseModel: EventsModel;
  // isCreate: boolean = false;
  selectedStageValue: string = '';
  selectedBureauValue: string = '';
  selectedLieuValue: string = '';
  private openZoom: boolean = false;
  public zoom: boolean = false;
  private sub: Subscription;

  @Input('param') param: QueovalParam;
  @Output() sendBreadcrump: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>();
  @Output() sendEvent: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>();
  @ViewChild('closeDelete', { static: false }) closeDelete: ElementRef;

  constructor(
    private dialogservice: DialogService,
    public indParam: CoreService,
    private httpService: HttpService,
    private toast: ToastService,
    private agenda: AgendaQueovalService
  ) {}

  ngOnInit(): void {
    this.paramModel = this.param.model as BObjectModel;
    if (!this.paramModel) {
      this.toast.showAlertToast('paramètre d\'entrée incorrect');
      return;
    }

    this.dialogservice.showSplash(true);

    this.globalSaveStage = false;
    this.param.model.ShowRemoveButton = false;
    this.param.model.ShowSaveButton = false;

    const code: BreadDik[] = this.param.params.filter((element: BreadDik) => element.key === 'code');
    if (code && code.length > 0) {
      // this.isCreate = this.paramModel.IdDonneeFils === '0';
      this.sub = this.httpService.getHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/GETINIT/${this.paramModel.IdDonneeFils}|${code[0].value}|${this.paramModel.IdRelation}|${this.agenda.UserAgendaID}`).subscribe((data: EventsModel) => {
        if (!data.HasError) {
          this.baseModel = data;
          if (this.baseModel && this.baseModel.DataReservation && this.baseModel.DataReservation.ListStagiaires && this.baseModel.DataReservation.ListStagiaires.length > 0) {
            if (!this.presencesHaveSameValues()) {
              this.globalPresence = "";
            } else {
              this.globalPresence = this.baseModel.DataReservation.ListStagiaires[0].presence;
            }
          }

          this.selectedStageValue = data.DataReservation.SelectedStages && data.DataReservation.SelectedStages.length > 0
            ? data.DataReservation.SelectedStages[0].Value : '';
          this.selectedBureauValue = data.DataReservation.SelectedBureau
            ? data.DataReservation.SelectedBureau.Value : '';
          this.selectedLieuValue = data.DataReservation.SelectedLieu
            ? data.DataReservation.SelectedLieu.Value : '';
          this.dialogservice.showSplash(false);

          this.AfficheUser();
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  public pageLoaded(): void {
    setTimeout(() => { this.zoom = document.getElementById('BtnZoom') ? true : false; }, 0);
  }


  public afficheZoneParticipantBT(list: BlockTree[]): boolean {
    for (const groupe of list) {
      for (const item of groupe.Children)
        if (item.IsChecked) {
          return true;
        }
    }
    return false;
  }


  /** @description search stage click event
   * @param element the selected stage element
   * @return
   */
  public getSelectedStage(element: QueovalItem): void {
    this.baseModel.DataReservation.SelectedStages = [];
    if (element && element.Value === 'DELETE') {     
      this.baseModel.DataReservation.ListStagiaires = [];
    } else {
      this.baseModel.DataReservation.SelectedStages.push(element);
      this.httpService.getHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/GETSTAGEBOUNDDATA/${this.paramModel.IdDonneeFils}|${element.Value}`).subscribe((data: EventsModel) => {
        if (!data.HasError) {
          this.baseModel.DataReservation.ListStagiaires = data.DataReservation.ListStagiaires;
          this.baseModel.DataReservation.ListLieux = data.DataReservation.ListLieux;
          // this.baseModel.DataReservation.SelectedLieu = data.DataReservation.SelectedLieu;
          // this.selectedLieuValue = data.DataReservation.SelectedLieu
          //   ? data.DataReservation.SelectedLieu.Value : '';
        }
      });
    }
  }

  /** @description select bureau change event
   * @param element the selected bureau ident
   * @return
   */
  public selectBureau(idbureau: string): void {
    const lb: QueovalItem[] = this.baseModel.DataReservation.ListBureaux.filter((e: QueovalItem) => e.Value === idbureau);
    if (lb && lb.length > 0) {
      this.baseModel.DataReservation.SelectedBureau = lb[0];
      return;
    }
    this.baseModel.DataReservation.SelectedBureau = new QueovalItem();
    this.baseModel.DataReservation.SelectedBureau.Value = '0';
    this.baseModel.DataReservation.SelectedBureau.Text = '';
  }

  public selectLieu(idLieu: string): void {
    const lb: QueovalItem[] = this.baseModel.DataReservation.ListLieux.filter((e: QueovalItem) => e.Value === idLieu);
    if (lb && lb.length > 0) {
      this.baseModel.DataReservation.SelectedLieu = lb[0];
      return;
    }
  }

  // Ajout / Retrait d'un groupe de collaborateur
  public moveItemGroup(itemGroup: BlockTree, mode: string): void {
    itemGroup.IsChecked = !itemGroup.IsChecked;
    // Même chose pour tous les utilisateurs du groupe ( en cascade)
    itemGroup.Children.forEach((user: BlockTree) => {
      user.IsChecked = itemGroup.IsChecked;
    });
    if (mode === 'C') {
      itemGroup.Children.forEach((user: BlockTree) => {
        this.propItems(this.baseModel.DataReservation.ListParticipants.Children, user.Value, user.IsChecked);
      });
    }
    this.AfficheUser();
  }

  /** @description check/uncheck item from objects and collabo lists
   * @return
   */
  public moveItem(itemGroup: BlockTree, item: BlockTree, mode: string): void {
    item.IsChecked = !item.IsChecked;
    // Si on décoche 1 user alors le groupe doit être décoché
    if (!item.IsChecked) {
      itemGroup.IsChecked = false;
    }
    if (mode === 'C') {
      this.propItems(this.baseModel.DataReservation.ListParticipants.Children, item.Value, item.IsChecked);
    }
    this.AfficheUser();
  }


  private AfficheUser(): void {
    //liste des participants déjà visibles
    const ListParticipants: Array<string> = new Array<string>();

    //pour chaque occurence de l'utilisateur passé en paramètre dans chaque groupe
    this.baseModel.DataReservation.ListParticipants.Children.forEach((groupe: BlockTree) => {
      groupe.Children.forEach((user: BlockTree) => {
        //on le cache si il n'est pas check
        if (!user.IsChecked) {
          user.IsVisible = false;
        } else {
          //on le rend visible si il n'est pas déjà dans la liste des participants visibles
          if (!ListParticipants.includes(user.Value)) {
            ListParticipants.push(user.Value);
            user.IsVisible = true;
          } else {
            user.IsVisible = false;
          }
        }
      });
    });
  }

  // S'il y a au moins 1 collaborateur coché dans le groupe
  public oneUserCheckInGrp(groupe: BlockTree): boolean {
    const ckl: Array<BlockTree> = groupe.Children.filter((c: BlockTree) => c.IsChecked);
    return ckl && ckl.length > 0;
  }

  public allUserCheckInGrp(groupe: BlockTree): boolean {
    const ckl: Array<BlockTree> = groupe.Children.filter((c: BlockTree) => c.IsChecked);
    return ckl && ckl.length === groupe.Children.length;
  }

  public saveResaAndOpenZoom(): void {
    this.openZoom = true;
    this.globalSaveStage = false;
    setTimeout(() => {
      this.globalSaveStage = true;
    }, 0);
  }

  /** @description save reservation click event
   * @return
   */
  public SaveResa(): void {
    //////if (!this.baseModel.DataReservation.SelectedStage || this.baseModel.DataReservation.SelectedStage.Value === '0') {
    //////  this.toast.showAlertToast('select a stage for the reservation');
    //////  return;
    //////}
    this.globalSaveStage = false;
    setTimeout(() => {
      this.globalSaveStage = true;
    }, 0);
  }

  /** @description afetr saving bo data
   * @return
   */
  public getIdBoResa(BOEvent: BObjectModel): void {
    if (BOEvent && BOEvent.Error !== 'NOTVALID') {
      if (this.globalSaveStage) {
        this.globalSaveStage = false;
        this.dialogservice.showSplash(true);
        this.baseModel.EventId = BOEvent.IdDonneeFils;
        this.baseModel.Mode = 'SAVERESA';
        this.httpService.postHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/`, this.baseModel).subscribe((response: EventsModel) => {
          if (!response.HasError) {
            // this.dialogservice.showSplash(false);
            this.baseModel = response;
            if (this.openZoom) {
              const p: Array<BreadDik> = new Array<BreadDik>();
              p.push(new BreadDik('params', ''));
              const param: { params: Array<BreadDik>, model: BObjectModel } = { params: p, model: BOEvent };
              const breadCrumbItem: BreadcrumbModel = new BreadcrumbModel('', 'zoom', param, 'Zoom', true);
              this.sendBreadcrump.emit(breadCrumbItem);

            } else {
              this.sendEvent.emit(new BreadcrumbModel('back', '', null, '', false));
            }
          }
          this.dialogservice.showSplash(false);
        });
      }
    } else {
      this.globalSaveStage = false;
      this.openZoom = false;
      this.dialogservice.showSplash(false);
    }
  }

  public UpdatePresence(value: string, stage: Apprenant): void {
    if (stage.presence === value) {
      stage.presence = '';
    } else {
      stage.presence = value;
    }
    if (!this.presencesHaveSameValues()) {
      this.globalPresence = "";
    } else {
      this.globalPresence = stage.presence;
    }
  }

  public presencesHaveSameValues(): boolean {
    for (let i: number = 0; i < this.baseModel.DataReservation.ListStagiaires.length; i++) {
      const stage: Apprenant = this.baseModel.DataReservation.ListStagiaires[i];
      if (stage.presence !== this.baseModel.DataReservation.ListStagiaires[0].presence) {
        return false;
      }
    }
    return true;
  }

  // Fermeture de la modale de suppression
  public closeModalDelete(): void {
    this.closeDelete.nativeElement.click();
  }

  // Confirmation de la suppression du rendez-vous
  public confirmDelete(): void {
    const model: EventsModel = this.baseModel;
    this.dialogservice.showSplash(true);
    model.Mode = 'DELETERESA';
    this.httpService.postHttp<EventsModel>(`${this.indParam.AppParams.apiUrl}api/Events/`, model).subscribe((data: EventsModel) => {
      if (!data.HasError) {
        this.baseModel = data;
        this.dialogservice.showSplash(false);
        if (data.Alert && data.Alert !== '') {
          this.toast.showWarningToast(data.Alert);
        } else {
          // Message succes + redirection
          this.closeModalDelete();
          this.sendEvent.emit(new BreadcrumbModel('back', '', null, '', false));
          this.toast.showSuccessToast('Rendez-vous supprimé');
        }
      }
    });
  }

  public setRadio(value: string): void {
    if (this.globalPresence === value) {
      this.baseModel.DataReservation.ListStagiaires.forEach((i: Apprenant) => i.presence = "");
      this.globalPresence = "";
    } else {
      this.baseModel.DataReservation.ListStagiaires.forEach((i: Apprenant) => i.presence = value);
      this.globalPresence = value;
    }
  }

  /** @description propagate objects and collabo lists selection on eventual identic items in groups
    * @return
    */
  private propItems(children: BlockTree[], itemValue: string, itemCheck: boolean): void {
    children.forEach((e: BlockTree) => {
      const r: BlockTree[] = e.Children.filter((x: BlockTree) => x.Value === itemValue);
      if (r) {
        r.forEach((y: BlockTree) => y.IsChecked = itemCheck);
      }
    });
  }
}

